import { Asset, EntryCollection, EntryFields } from "contentful";

export interface User {
  id: string;
  emailAddress: string;
  isAdmin?: boolean;
}

export type ContentfulPhysicalProduct = {
  name: EntryFields.Text;
  slug: EntryFields.Text;
  type: EntryFields.Text;
  subtype?: EntryFields.Text;
  maxQuantity: EntryFields.Number;
  orderedQuantity: EntryFields.Number;
  longDescription: EntryFields.Text;
  priceCents: EntryFields.Number;
  images: Asset[];
  profileImages: Asset[];
  fontsInUse: EntryFields.Text[];
  technicalDetails?: EntryFields.Text;
  careInformation?: EntryFields.Text;
  imageDisplayMode: EntryFields.Text;
  relatedProducts: any;
};

export type FontName =
  | "monochromic"
  | "felicette"
  | "ampersandist"
  | "nebulith"
  | "constant";

export enum PhysicalProductType {
  Print = "print",
  Zine = "zine",
  Fabric = "fabric",
}

// An optional further categorization of a physical product. Subtypes are used to
// apply discounts across products that are sold as a set (see lib/models/Discounts).
export enum PhysicalProductSubtype {
  LargePrint = "large_print",
}
